import { render, staticRenderFns } from "./votingRecordsManage.vue?vue&type=template&id=6e174cf1&scoped=true&"
import script from "./votingRecordsManage.vue?vue&type=script&lang=ts&"
export * from "./votingRecordsManage.vue?vue&type=script&lang=ts&"
import style0 from "./votingRecordsManage.vue?vue&type=style&index=0&id=6e174cf1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e174cf1",
  null
  
)

export default component.exports